module.exports = __webpack_public_path__ + "img/mala-de-dinheiro.8edec267.svg";